module.exports = __webpack_public_path__ + "static/img/source2.575fa55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/en/source2.jpg
// module id = Wjqz
// module chunks = 1